import Vue from 'vue'
import { mapState } from 'vuex'

import Button from '@/components/button/basic-button.vue'

interface Data {
  email: string
  password: string
}

export default Vue.extend({
  name: 'Login',

  components: {
    'v-button': Button
  },

  data(): Data {
    return {
      email: process.env.VUE_APP_IS_TEST_ENV === 'true' ? 'user1@test.co.jp' : '',
      password: process.env.VUE_APP_IS_TEST_ENV === 'true' ? 'password' : '',
    }
  },

  created() {
    this.$store.dispatch('loading', false)
    this.$store.dispatch('clearMessage')
  },

  computed: {
    ...mapState(['loading', 'message']),
  },

  methods: {
    handleLogin() {
      this.$store.dispatch('clearMessage')
      this.$store.dispatch('loading')
      this.$nextTick(() => {
        this.$store.dispatch('login', { email: this.email, password: this.password })
          .then(() => {
            this.$router.push({ path: '/dashboard' })
          })
          .catch(() => {
            this.$store.dispatch('loading', false)
          })
      })
    },

    handleRegister() {
      this.$router.push({ path: '/register' })
    },

    handleForgotPassword() {
      this.$router.push({ path: '/reset_password' })
    }
  }
})
